<template>
  <div class="pt-2">
    <vs-text-input label="Search IronSight network" :value="search" autofocus @input="updateSearch">
      <template #append>
        <v-icon>search</v-icon>
      </template>
    </vs-text-input>

    <vs-text v-if="search.length === 0" type="caption" class="pt-1">
      Search for an existing client before creating a new one
    </vs-text>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsText from '@/components/vision/VsText.vue'

const search = ref('')

const emit = defineEmits<{
  (e: 'update-search', initialClientName: string)
}>()

function updateSearch(newSearch: string) {
  search.value = newSearch

  emit('update-search', search.value)
}
</script>
